<template>
  <!-- FLIGHT -->
  <div class="item-container">
    <div :id="`itemexpander-${item.jsonid}`" class="item-main" :class="{ 'item-active': dropdown }"
      @click="toggleExpand">
      <div class="item-title">
        <i class="icon-flight glyph-lg mr-3" />
        <span v-if="!flightImg">{{ item.jsontype.toUpperCase() }}</span>
        <div>
          <img v-if="item.vendor" class="vendor-logo-img"
            :src="`https://www.trailfinders.com/graphics/flights/${item.vendor}.gif`" />
        </div>
        <span>FLIGHT
          {{ item.flightno.toUpperCase() !== 'FLIGHT' ? item.flightno.toUpperCase() : '' }}</span>
      </div>

      <!-- DESKTOP VIEW -->
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>{{ item.cityfrom }} to {{ item.cityto }}</h6>
        <p>
          with {{ item.suppliername }}<span v-if="item.class"> in {{ item.class }}</span>
        </p>

        <!-- Fare Brand Toggle Modal -->
        <div v-if="hasFareBrands" class="d-flex">
          <h6>
            Fare Brand:
          </h6>
          <h6 class="fare-brand-link pl-2" @click="showFareBrands">
            {{ item.fltbrandname }}
          </h6>
        </div>
      </div>

      <div class="item-main-desktop">
        <h6>Departing at {{ item.deptime }}</h6>
        <p>
          Arriving at {{ item.arrtime }}
          <span v-if="item.arrdate && item.arrdate !== item.depdate">({{ item.arrdate }})</span>
        </p>
        <div v-if="showCheckinLink()">
          <a v-if="item.vendorloc && bookingInfo.fil !== 'P'" :href="item.checkininfo.link" target="_blank"
            class="flight-checkin-active-link pr-1">Airline Ref:
          </a>
          {{ item.vendorloc }}
        </div>
        <div v-else>
          <p v-if="item.vendorloc && bookingInfo.fil !== 'P' && !friendFamily">
            <span class="flight-checkin-active-link pr-1">Airline Ref:</span>
            <span class="flight-checkin-active-link-ref">{{ item.vendorloc }}</span>
          </p>
        </div>
      </div>
      
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>

    <div v-if="item.itinmsg" class="flights-itinerary-message pt-3">
      {{ item.itinmsg }}
    </div>

    <div v-if="dropdown" class="item-dropdown desktop-dropdown-flight">
      <ul v-if="item.status || filteredExpanderItems.length > 0 || item.fnotes[0]">
        <!-- Loop over all expanderItems -->
        <li v-for="expanderItem in filteredExpanderItems" :key="expanderItem.title">
          <h4>{{ expanderItem.title }}</h4>
          <p style="padding-top: 12px; padding-left: 8px">
            {{ expanderItem.notes }}
          </p>
        </li>
      </ul>
      <div v-if="item.fnotes[0] && item.fnotes[0] !== '***.****'" class="extra-info-notes">
        Notes
        <ul style="border-top: 0px solid; padding-top: 0px; margin-top: 0px">
          <li v-for="(note, index) in item.fnotes" :key="index">
            <p style="padding-top: 12px">
              {{ note }}
            </p>
          </li>
        </ul>
      </div>
    </div>

    <!-- MOBILE VIEW: This will only be displayed on mobile devices -->
    <div v-if="dropdown" class="item-dropdown flight-dropdown">
      <ul class="mobile-dropdown-flight">
        <li v-if="item.cityfrom">
          <h4>Departing from</h4>
          <p>{{ item.cityfrom }}</p>
        </li>
        <li v-if="item.cityto">
          <h4>To</h4>
          <p>{{ item.cityto }}</p>
        </li>
        <li v-if="item.deptime">
          <h4>Departing at</h4>
          <p>{{ item.deptime }}</p>
        </li>
        <li v-if="item.arrtime">
          <h4>Arriving at</h4>
          <p>
            {{ item.arrtime }}
            <span v-if="item.arrdate && item.arrdate !== item.depdate">({{ item.arrdate }})</span>
          </p>
        </li>
        <li v-if="item.suppliername">
          <p>
            with {{ item.suppliername }}<span v-if="item.class"> in {{ item.class }}</span>
          </p>
        </li>
        <li class="py-3">
          <a v-if="item.vendorloc && bookingInfo.fil !== 'P'"
            :href="item && item.checkininfo && item.checkininfo.link ? item.checkininfo.link : ''"
            target="_blank">Airline Ref:
          </a>
          {{ item.vendorloc }}
        </li>
      </ul>
    </div>
    <div v-if="dropdown" class="item-dropdown mobile-dropdown-item mobile-dropdown-flight">
      <ul>
        <li v-if="item.status">
          <h4>Status</h4>
          <p>{{ item.status }}</p>
        </li>
      </ul>
      <ul v-if="filteredExpanderItems.length">
        <!-- Loop over all expanderItems -->
        <li v-for="expanderItem in filteredExpanderItems" :key="expanderItem.title">
          <h4>{{ expanderItem.title }}</h4>
          <p style="padding-top: 12px;">
            {{ expanderItem.notes }}
          </p>
        </li>
      </ul>

      <!-- Fare Brand Toggle Modal -->
      <ul v-if="hasFareBrands">
        <li>
          <h4>
            Fare Brand:
          </h4>
          <h6 class="fare-brand-link pt-2" @click="showFareBrands">
            {{ item.fltbrandname }}
          </h6>
        </li>
      </ul>

      <div v-if="item.fnotes[0] && item.fnotes[0] !== '***.****'" class="extra-info-notes">
        Notes
        <ul style="border-top: 0px solid; padding-top: 0px; margin-top: 0px">
          <li v-for="(note, index) in item.fnotes" :key="index">
            <p style="padding-top: 12px">
              {{ note }}
            </p>
          </li>
        </ul>
      </div>
    </div>

    <!-- Flight buttons -->
    <div v-if="!friendFamily && !nothingToDisplay && dropdown" class="flight-baggage">
      <div v-if="!isSupplierFlight" class="baggage-btn-container pl-2" :id="checkIfButtonsNeedResizing">
        <a v-if="displayManageFlight" class="btn-link" target="_blank" @click="getManageBookingLink">
          <button class="itin-flight-btn" :class="{ 'checkin-link-btn': showCheckinLink() }">
            <i v-if="showCheckinLink()" class="icon-check_in glyph-md" :class="{ 'checkin-link': showCheckinLink() }" />
            <i v-else class="icon-manage_and_check_in glyph-md" />
            <span :class="{ 'checkin-link': showCheckinLink() }">
              {{ showCheckinLink() ? 'Check In Now' : 'Manage Booking' }}
            </span>
          </button>
        </a>

        <button v-if="flightsdata === 'true' && !bookedByCustomer && flights && flights.length" class="itin-flight-btn"
          @click="showDetailedFlightsInfo(item.flightno)">
          <i class="icon-flight_info glyph-md" />
          <span>Detailed Flight Information</span>
        </button>

        <button v-if="displayEticketsButton && !bookedByCustomer" class="itin-flight-btn" @click="showETickets">
          <i class="icon-e_ticket_numbers glyph-md" />
          <span>E-Ticket Numbers</span>
        </button>
        <button v-if="sqlAirlineInfoShow && !bookedByCustomer" class="itin-flight-btn" @click="showAirlineInfo">
          <i class="icon-flight glyph-md" />
          <span>Airline Information</span>
        </button>
        <button v-if="!bookedByCustomer" class="itin-flight-btn" @click="showSeating">
          <i class="icon-seating glyph-md" />
          <span>Seating Information </span>
        </button>
        <button v-if="hasAdditionalRequests" class="itin-flight-btn" @click="showAdditionalRequests(item.flightno)">
          <i class="icon-information glyph-md" />
          <span>Additional Requests</span>
        </button>
        <button v-if="!bookedByCustomer" class="itin-flight-btn" @click="showHandBaggage(item.flightno)">
          <i class="icon-cabin_bag glyph-md" />
          <span>Hand Baggage</span>
        </button>
        <button v-if="!bookedByCustomer" class="itin-flight-btn" @click="showCheckedBaggage(item.flightno)">
          <i class="icon-checked_baggage glyph-md" />
          <span>Checked Baggage</span>
        </button>
      </div>
    </div>

    <!-- If a superfacts checkin line is present -->
    <div v-if="item.checkin && item.checkininfo && dropdown" class="flight-checkin"
      :class="{ 'flight-checkin-active pl-3': checkinDropdown }">
      <p>CHECK-IN INFORMATION</p>
      <div class="toggle">
        <span v-if="!checkinDropdown" @click="handleCheckinDropdown">+</span>
        <span v-else @click="handleCheckinDropdown">-</span>
      </div>
    </div>
    <div v-if="item.checkin && item.checkininfo && checkinDropdown && dropdown" class="flight-checkin-dropdown pl-4">
      <p>
        <strong>Online check in opens
          {{
            Number(item.checkininfo.time) % 24 === 0 && Number(item.checkininfo.time) > 96
              ? `${item.checkininfo.time / 24} days`
              : `${item.checkininfo.time} hours`
          }}
          before departure.</strong> Trailfinders strongly recommends checking-in online as soon as it opens, as airlines tend to give lowest priority to those who check in at the airport. It is your responsibility to check the timing of your flight is unchanged.
      </p>
      <div v-for="code in item.checkin.split(',')" :key="code.message">
        <span>{{ code }}</span>
      </div>
      <div v-if="showCheckinLink()">
        <a :href="item && item.checkininfo && item.checkininfo.link ? item.checkininfo.link : ''" target="_blank">Click
          here</a>
        to visit {{ item.checkininfo.name }} online check-in
      </div>
    </div>
    <AirlineTicket ref="AirlineTicketRef" />
    <CheckedBaggage ref="CheckedBaggageRef" :itineraryArr="itineraryArr" />
    <HandBaggage ref="HandBaggageRef" :itineraryArr="itineraryArr" />
    <SQLMessage ref="SQLMessageRef" />
    <DetailedFlights ref="DetailedFlightsRef" />
    <AdditionalRequests v-if="hasAdditionalRequests" ref="AdditionalRequestsRef" :itineraryArr="itineraryArr" />
    <SeatingMessagesModal 
      ref="SeatingMessagesModalRef" 
      @issue-flights-response="handleIssueFlightsResponse" 
      @openDetailedFlightsInfo="openDetailedFlightsInfo"
    />
    <MakeAPayment ref="MakeAPayment" />
    <FareBrandsModal
      v-if="hasFareBrands"
      ref="FareBrandsModalRef"
      :title="`Fare Brand: ${item.fltbrandname}`"
      :fareBrands="item.farebrands"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AirlineTicket from '@/modules/menu-bar/essential-info/airline-etickets'
import CheckedBaggage from '@/modules/menu-bar/essential-info/baggage/checked'
import HandBaggage from '@/modules/menu-bar/essential-info/baggage/hand'
import SQLMessage from '@/modules/menu-bar/essential-info/sql-message'
import DetailedFlights from '@/modules/navigation/modals/detailed-flights'
import AdditionalRequests from '@/modules/menu-bar/essential-info/additional-requests'
import SeatingMessagesModal from "@/modules/navigation/modals/seating-messages"
import MakeAPayment from "@/modules/navigation/modals/payment-hub/make-payment";
import FareBrandsModal from "./modals/fare-brands-modal";
import dayjs from '@/lib/dayjs'
export default {
  components: {
    AirlineTicket,
    CheckedBaggage,
    HandBaggage,
    SQLMessage,
    DetailedFlights,
    AdditionalRequests,
    SeatingMessagesModal,
    MakeAPayment,
    FareBrandsModal,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      dropdown: true,
      checkinDropdown: false,
      flightImg: 'https://www.trailfinders.com/graphics/flights/VS.gif',
      sqlSeating: {},
      sqlAirlineInfo: {},
      sqlAirlineInfoShow: false,
      activeAlerts: [],
      appInstall: false,
      source: 'EXT',
      fil: 'M',
      country: 'UK',
      showAppInstallExt: false,
      showAppInstallInt: false,
      show: 'UK',
      referer: 'com',
      regex: /\w+\s+/g,
    }
  },
  async mounted() {
    if (this.item.checkininfo) {
      this.checkinDropdown = true
    }
    if (this.essentialInfoMenu) {
      this.setSeating()
      this.setAirlineInfo()
    }
    this.$root.$on('collapseall', () => {
      this.collapseAll()
    })
    this.$root.$on('expandall', () => {
      this.expandAll()
    })
    if (this.$route.params.source) {
      this.source = this.$route.params.source.toUpperCase()
    }
    this.fil = this.getFil
    this.country = await this.getCountry
    if (this.country === 'IE') {
      this.referer = 'ie'
    }
    this.activeAlerts = this.getDescLinks
  },
  computed: {
    ...mapGetters({
      bookingInfo: 'booking/getBookingInfo',
      friendFamily: 'friendFamily/isFriendFamily',
      essentialInfoMenu: 'essentialInfoMenu/getMenu',
      getFil: 'booking/getFil',
      getDescLinks: 'booking/getDescLinks',
      getCountry: 'booking/getCountry',
      flightsdata: 'booking/getLiveFlights',
      itinerary: 'booking/getItinerary',
      flights: "flights/getFlights",
    }),
    itineraryArr() {
      const flatItinArr = []
      this.itinerary.items.forEach((item) => {
        item.data.forEach((dataItem) => {
          if (dataItem.flightno) {
            flatItinArr.push(dataItem)
          }
        })
      })
      return flatItinArr
    },
    displayManageFlight() {
      // This is only for provisional bookings and account info has atol protected = TRUE
      if (this.getFil === 'M' && this.item.checkininfo && this.item.checkininfo.link) {
        return true
      } else {
        return false
      }
    },
    displayEticketsButton() {
      let displayButton = false
      this.essentialInfoMenu.forEach((info) => {
        if (Array.isArray(info.submenu)) {
          info.submenu.forEach((item) => {
            if (item.title === 'Airline E-Ticket Numbers') {
              displayButton = true
            }
          })
        }
      })
      return displayButton
    },
    isSupplierFlight() {
      return this.item.suppliercode && this.item.suppliercode === 'ZZZ' ? true : false
    },
    bookedByCustomer() {
      let booked
      if (this.item.itinmsg.includes('This flight has been booked by you, directly') || this.item.statusonrecord === 'PENDING') {
        booked = true
      } else {
        booked = false
      }
      return booked
    },
    nothingToDisplay() {
      if (this.bookedByCustomer && !this.displayEticketsButton && !this.displayManageFlight) {
        return true
      }
      return false
    },
    hasAdditionalRequests() {
      const flightBricks = []
      this.itinerary.items.forEach((item) => {
        item.data.forEach((dataItem) => {
          if (dataItem.jsontype === 'flight') {
            flightBricks.push(dataItem)
          }
        })
      })
      const filterRequests = flightBricks.filter((brick) => brick.servicerequests.length > 0)
      return filterRequests.length > 0 ? true : false
    },
    checkIfButtonsNeedResizing() {
      // if all the flight buttons (such as manage booking, baggage etc) appear, the buttons overhang unless we reduce the size of the margin between the buttons, using the id "reduced-size-itin-flight-btns" in the wrapper div
      if (
        this.displayManageFlight &&
        this.flightsdata === "true" &&
        !this.bookedByCustomer &&
        this.displayEticketsButton &&
        this.sqlAirlineInfoShow &&
        Object.keys(this.sqlSeating).includes("sqlCodes") &&
        this.hasAdditionalRequests
      ) {
        return "reduced-size-itin-flight-btns";
      }
      return "";
    },
    hasFareBrands() {
      // Superfacts sends [""] rather than an empty array, so check for at least one real brand
      return this.item.fltbrandname && (this.item.farebrands && this.item.farebrands.some((brand) => brand && brand.vt_text))
    },
    filteredExpanderItems() {
      // Fare Type is always hidden here (replaced by the Fare Brand link where fare brands exist)
      if (!this.item.expanderItems) {
        return []
      }
      return this.item.expanderItems.filter((expanderItem) => expanderItem.title !== 'Fare Type')
    },
  },
  methods: {
    getManageBookingLink() {
      if (this.item.checkininfo && this.item.checkininfo.code && this.item.checkininfo.code === 'BA') {
        // If BA get BA link
        if (this.checkIfActive('ba_manage_my_booking')) {
          this.mmbLink('ba')
          return
        }
      }
      // Otherwise check if there is a manageLink and if not use the link regardless
      if (!this.item.checkininfo.manageLink) {
        window.open(this.item.checkininfo.link, '_new')
      } else {
        // If managerLink is available, check status and if checkin available use link, if not use manageLink
        if (this.showCheckinLink()) {
          window.open(this.item.checkininfo.link, '_new')
        } else {
          window.open(this.item.checkininfo.manageLink, '_new')
        }
      }
    },
    checkIfActive(alertType) {
      if (this.getDescLinks && this.getDescLinks.indexOf(alertType) !== -1) {
        return true
      }
    },
    mmbLink(_airline) {
      let _surname = this.bookingInfo.lead_surname
      let _airlineRef = this.item.vendorloc

      //if multiple gals for different clients, item.names will have a value, otherwise all passengers on the same flight
      if (this.item.names) {
        // gets the surname by splitting passengers into an array and taking the first passenger, and then splitting again to split into TITLE/FIRSTNAME/SURNAME, and grabs the last name. In the rare instance of multiple gals and double-barrel surname (e.g. Mr John Smith Jones), this will fail - but will still take the user to the BA manage booking page
        _surname = this.item.names.split(', ')[0].split(' ').reverse()[0]
      }

      window.open(
        `https://www.trailfinders.${this.referer}/api/forward/${_airline}?lastname=${_surname}&bookingref=${_airlineRef}`,
        '_new'
      )
    },
    setSeating() {
      this.essentialInfoMenu.forEach((info) => {
        if (Array.isArray(info.submenu)) {
          info.submenu.forEach((item) => {
            if (item.partial === 'SQLMessageRef' && item.title === 'Seating') {
              this.sqlSeating = item
            }
          })
        }
      })
    },
    setAirlineInfo() {
      this.essentialInfoMenu.forEach((info) => {
        if (Array.isArray(info.submenu)) {
          info.submenu.forEach((item) => {
            if (item.partial === 'SQLMessageRef' && item.title === 'Airline Information') {
              this.sqlAirlineInfo = item
              if (
                Object.keys(this.sqlAirlineInfo).includes('sqlCodes') &&
                this.sqlAirlineInfo.sqlCodes[0]
              ) {
                this.sqlAirlineInfoShow = true
              }
            }
          })
        }
        // vt-api hangs free text notes (currently Ryanair) off the Air Travel
        // item itself rather than a submenu entry, so merge those in too
        if (info.title === 'Air Travel' && Array.isArray(info.message)) {
          this.sqlAirlineInfo = {
            ...this.sqlAirlineInfo,
            title: 'Airline Information',
            message: info.message,
          }
          this.sqlAirlineInfoShow = true
        }
      })
    },
    toggleExpand() {
      this.dropdown = !this.dropdown
    },
    expandAll() {
      this.dropdown = true
      this.checkinDropdown = true
    },
    collapseAll() {
      this.dropdown = false
      this.checkinDropdown = false
    },
    handleDropdown() {
      this.dropdown = !this.dropdown
    },
    showCheckedBaggage(flightNo) {
      this.$refs.CheckedBaggageRef.showModal(flightNo)
    },
    showHandBaggage(flightNo) {
      this.$refs.HandBaggageRef.showModal(flightNo)
    },
    showSeating() {
      this.$refs.SeatingMessagesModalRef.showModal({ from: 'itinerary' })
    },
    showFareBrands() {
      this.$refs.FareBrandsModalRef.showModal()
    },
    showAdditionalRequests(flightNo) {
      this.$refs.AdditionalRequestsRef.showModal(flightNo)
    },
    showAirlineInfo() {
      this.$refs.SQLMessageRef.showModal(this.sqlAirlineInfo)
    },
    showDetailedFlightsInfo(flightNo) {
      this.$refs.DetailedFlightsRef.showModal(flightNo)
    },
    showETickets() {
      this.$refs['AirlineTicketRef'].showModal({
        partial: 'AirlineTicketRef',
        title: 'Airline E-Ticket Numbers',
      })
    },
    handleCheckinDropdown() {
      this.checkinDropdown = !this.checkinDropdown
    },
    showCheckinLink() {
      if (this.item.checkininfo && this.item.checkininfo.link) {
        // Set departure time
        const _departDate = dayjs(new Date(`${this.item.depdate} ${this.item.deptime}`))
        // Set checkin time
        const _checkinTime = dayjs(new Date(`${this.item.depdate} ${this.item.deptime}`)).subtract(
          this.item.checkininfo.time,
          'hours'
        )
        // Set today
        let _today = dayjs()
        // Get difference in hours between today and departure time
        const duration = dayjs.duration(_today.diff(_departDate))
        const hours = duration.asHours()
        if (_departDate >= _today && _checkinTime <= _today) {
          return true
        } else if (_departDate <= _today.add(24, 'hours') && hours < 24) {
          return true
        }
      }
      return false
      // return true
    },
    handleIssueFlightsResponse(agreed) {
      if (agreed) {
        this.$refs.MakeAPayment.showModal({ issueFlights: true });
        // show payment modal with checkbox pre-ticked
      }
    },
    openDetailedFlightsInfo() {
      this.$refs.DetailedFlightsRef.showModal()
    }
  },
}
</script>

<style lang="scss">
@import '../../styles.scss';

.fare-brand-link {
  color: orange;
  font-weight: 600;
  text-decoration: underline;
}

.notes-item-dropdown {
  padding: 20px !important;
  font-weight: 100;
}

.btn-link:hover {
  text-decoration: none;
  color: #fff;
}

.checkin-link {
  margin-bottom: 1em;
}
</style>